import { getItemType, getPaddingsClassFromData } from "@/utils/utils"
import React, { useCallback, useState } from "react"
import HistoryItem from "@/components/PinnedHistoryModule/HistoryItem"
import HistoryElevator from "@/components/PinnedHistoryModule/Elevator"
import styled from "styled-components"
import { CONTENT_TYPES } from "@/constants"
import HighlightedHeading from "@/components/HighlightedHeading"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
`

const Elevator = styled(HistoryElevator)`
	position: absolute;
	right: 30px;
	top: 0;
	//top: 50svh;
	//transform: translateY(50%);
	//translate: 0 -50svh ;
`

const Item = ({ data, index, key, isLastItem, onUpdate }) => {
	const type = getItemType(data)
	switch (type) {
		case CONTENT_TYPES.HISTORY_ITEM:
			return <HistoryItem key={key} data={data} index={index} isLastItem={isLastItem} onUpdate={onUpdate} />
		case CONTENT_TYPES.HIGHLIGHTED_HEADING_BLOCK:
			return <HighlightedHeading data={{ highlightedHeadingBlock: data }} />
		default:
			return null
	}
}

export default function PinnedHistoryModule({ data }) {
	const paddings = getPaddingsClassFromData(data)
	const items = data?.items || []
	const elevator = data?.elevator || false
	const [currentItemIndex, setCurrentItemIndex] = useState(0)
	const handleSTUpdate = useCallback(
		({ isActive, index }) => {
			if (!isActive || !elevator) return
			setCurrentItemIndex(index)
		},
		[elevator],
	)

	return (
		<Wrapper className={paddings}>
			<HeaderDescriptionBlock headerDescription={data?.headerDescription} />
			{elevator && <Elevator items={items} currIndex={currentItemIndex} />}
			{items.map((item, index) => {
				const key = item?.id || index
				const isLastItem = index === items.length - 1
				return <Item key={key} data={item} index={index} isLastItem={isLastItem} onUpdate={handleSTUpdate} />
			})}
		</Wrapper>
	)
}
